import { render, staticRenderFns } from "./BindsSubheader.vue?vue&type=template&id=600a41fc&"
import script from "./BindsSubheader.vue?vue&type=script&lang=js&"
export * from "./BindsSubheader.vue?vue&type=script&lang=js&"
import style0 from "./BindsSubheader.vue?vue&type=style&index=0&id=600a41fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports